<div class="container py-5">
  <h2 class="text-center">Our Services</h2>
  <div class="card-columns">
    <ng-container *ngFor="let item of alObj; let i = index;">
      <div class="card" *ngIf="i<20">
        <img class="card-img-top" src="{{item.thumbnailUrl}}" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title">{{item.title}}</h5>
          <p class="card-text">This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
        </div>
      </div>
    </ng-container>
  </div>
</div>